// extracted by mini-css-extract-plugin
export default {"container":"ProfileConsole_container__4zEwH","tabs":"ProfileConsole_tabs__Sqc0s","activeTab":"ProfileConsole_activeTab__s-xNS"};